// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageCarouselStyles } from "@stoneage/Overrides/Components/ProductImageCarousel";
import { css } from "styled-components";
import { color } from "@stoneage/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";

const getImageCss = (borderColor: string) => css`
    width: 100%;
    height: 100%;
    max-width: 52px;
    max-height: 52px;
    border: 1px solid ${color(borderColor)};
    cursor: pointer;
    justify-content: flex-start;
    img {
        max-width: 52px;
        max-height: 52px;
    }
`;

productImageCarouselStyles.mainContainer = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-top: 16px;
        gap: 12px;
        @media print {
            display: none;
        }
    `,
};

productImageCarouselStyles.carouselSlidesContainer = {
    css: css`
        align-items: ${({ isVertical }: any) => (isVertical ? "center" : "center")};
    `,
};

productImageCarouselStyles.carouselGridItem = {
    css: css`
        width: 100%;
        max-width: 258px;
    `,
};

productImageCarouselStyles.carouselSlide = {
    css: css`
        padding: 0 6px;
    `,
};

productImageCarouselStyles.prevArrowClickable = {
    css: css`
        &:hover > ${IconWrapper} {
            color: ${color("primary")};
        }

        &:disabled {
            opacity: 0.33;
        }
    `,
};

productImageCarouselStyles.nextArrowClickable = {
    css: css`
        &:hover > ${IconWrapper} {
            color: ${color("primary")};
        }

        &:disabled {
            opacity: 0.33;
        }
    `,
};

productImageCarouselStyles.arrowNavigationIcon = {
    size: 14,
    color: "common.ui7",
};

productImageCarouselStyles.image = {
    width: "52px",
    css: getImageCss("transparent"),
};

productImageCarouselStyles.selectedImage = {
    width: "52px",
    css: getImageCss("secondary"),
};
